import { prepareWorldBakes } from "./bakes.ts";
import { loadModels, MODEL_NAMES, type ModelName } from "./models.ts";
import { loadSurfaceMaps } from "./surface-textures.ts";

/** Models, decoded surface maps and the worker-side world bakes are all required before constructing a scene. */
export async function loadGameAssets(models: readonly ModelName[] = MODEL_NAMES): Promise<void> {
  await Promise.all([loadModels(models), loadSurfaceMaps(), prepareWorldBakes()]);
}
